import { useMemo } from 'react';
import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import queryString from 'query-string';

type History = ReturnType<typeof useHistory>;

export function useRouter(): {
  push: History['push'];
  replace: History['replace'];
  pathname: string;
  query: Record<string, string>;
  match: ReturnType<typeof useRouteMatch>;
  location: ReturnType<typeof useLocation>;
  history: History;
  getRouteParam: (key: string) => string | undefined;
} {
  const params = useParams();
  const location = useLocation();
  const history = useHistory();
  const match = useRouteMatch<Record<string, string | undefined>>();

  return useMemo(() => {
    const query: Record<string, string> = {
      ...queryString.parse(location.search),
      ...params,
    };

    return {
      push: history.push,
      replace: history.replace,
      pathname: location.pathname,
      query,
      match,
      location,
      history,
      getRouteParam: (key: string) => match.params[key],
    };
  }, [params, match, location, history]);
}
